module.exports = __webpack_public_path__ + "static/media/hackerrank.d38a06be.png";